export default __webpack_public_path__ + "static/media/success.89d5ba77.svg";